































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import VerticalStep from '@/components/ui/form/VerticalStep.vue'
import { TriggeredReferral } from '@/api/model/triggered-referral'

@Component({
    components: { VerticalStep },
})
export default class CreateAutoLeadVerticalStep1 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: TriggeredReferral
    @Inject() kenmerkLabel: (kenmerkId) => string

    get triggerType(): string {
        if (this.value.triggerType === 'agendaTypes') {
            return 'Afspraak'
        } else if (this.value.triggerType === 'taakTypes') {
            return 'Taak'
        } else if (this.value.triggerType === 'relatieTypes') {
            return 'Relatie'
        } else {
            return 'Kenmerk'
        }
    }

    get assignTypes(): string[] {
        if (this.value.triggerType === 'agendaTypes') {
            return this.value.agendaTypes
        } else if (this.value.triggerType === 'taakTypes') {
            return this.value.taakTypes
        } else if (this.value.triggerType === 'relatieTypes') {
            return this.value.relatieTypes
        } else {
            if (!this.value.realworksKenmerkId) {
                return ['-']
            }

            return [this.kenmerkLabel(this.value.realworksKenmerkId)]
        }
    }
}
